/**
 * Safety First – exclusive accordion
 */
(function () {
  'use strict';

  function initAccordion(root) {
    const items = root.querySelectorAll('[data-sf-item]');
    if (!items.length) return;

    items.forEach((item) => {
      const trigger = item.querySelector('[data-sf-trigger]');
      const panel = item.querySelector('[data-sf-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((other) => {
          const otherTrigger = other.querySelector('[data-sf-trigger]');
          const otherPanel = other.querySelector('[data-sf-panel]');
          other.classList.remove('is-open');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function initSection(sectionRoot) {
    const accordion = sectionRoot.querySelector('[data-sf-accordion]');
    if (accordion && accordion.dataset.sfReady !== 'true') {
      accordion.dataset.sfReady = 'true';
      initAccordion(accordion);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-safety-first]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-safety-first]');
    if (root) initSection(root);
  });
})();
